import { WidgetLegendSettings } from "components/settingsConfig/uiComponents/SettingsLegend";

export type RadarChartSettingsStateType = WidgetLegendSettings & {
  categoryCount: number;
  customWidgetTitle: string;
  dotSize?: number
  legendShow: boolean;
  showDots?: boolean;
  showLabel?: boolean;
  widgetTitle: string;
  widgetTitleAlignment: string;
}

export const radarChartDefaultSettings: RadarChartSettingsStateType = {
  categoryCount: 5,
  customWidgetTitle: '',
  dotSize: 3,
  legendShow: false,
  showDots: true,
  showLabel: true,
  widgetTitle: 'default',
  widgetTitleAlignment: 'left',
}